import { compose } from '@reduxjs/toolkit';
import { loadProfileReducer } from './loadProfile';

export const extraReducers = compose(loadProfileReducer);
export { loadProfileAction } from './loadProfile';
